import React, { useState } from "react";
import { Container, Form, Row, Col } from "react-bootstrap";
import { ToastContainer, toast } from "react-toastify";
import "./UnifiedFormStyles.css";
import AppButton from "../../Components/MerchantButton";

function InterestedMayaSolution({ navigation, primaryDetails, setPrimaryDetails }) {
  const [isError, setIsError] = useState({
    is_interested: false,
  });


  const MAYA_SOLUTION_OPTIONS = [
    "Yes",
    "No"
  ];

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setPrimaryDetails(prev => ({ ...prev,
      [name]: value,
    }));

    if (isError[name]) {
      setIsError({
        ...isError,
        [name]: false,
      });
    }
  };

  const validateForm = () => {
    const errors = {
      is_interested: !primaryDetails.is_interested,
    };

    setIsError(errors);

    const hasErrors = Object.values(errors).some(error => error);
    if (hasErrors) {
      toast.error("Please select an option", {
        autoClose: 3000,
        hideProgressBar: true,
        theme: "colored",
      });
      return false;
    }
    return true;
  };

  const isFormValid = () => {
    return !!primaryDetails.is_interested;
  };
  const handleNext = () => {
    if (validateForm()) {
      if (primaryDetails.is_interested === "No") {
        navigation.go("not-interested-maya-solution");
      } else {
        navigation.go("non-maya-merchant-info");
      }
    }
  };

  const handleBack = () => {
    if (navigation && navigation.previous) navigation.previous();
  };

  return (
    <div className="form-bg">
      <Container>
        <ToastContainer />
        <Row className="justify-content-md-center">

          {/* Main Form */}
          <Col md={10}>
              <div className="form-main-header">
                <h4 className="form-title">INTERESTED TO GET MAYA SOLUTION</h4>
                <p className="form-desc">Please select whether you are interested in getting MAYA solution</p>
              </div>
              <div className="form-main">
              <div className="form-main-content">
                <Form>
                  {/* Interested to get MAYA Solution Question */}
                  <Form.Group className="mb-5" controlId="is_interested">
                    <Form.Label className="form-label">
                      Interested to get MAYA Solution <span className="form-required">*</span>
                    </Form.Label>
                  
                    <div className="form-radio-group">
                      {MAYA_SOLUTION_OPTIONS.map((option, index) => (
                        <div
                          key={`maya-solution-${index}-${option}`}
                          className={`form-radio-item${primaryDetails.is_interested === option ? " selected" : ""}`}
                        >
                          <div className="form-radio-flex">
                            <Form.Check
                              type="radio"
                              name="is_interested"
                              value={option}
                              label={option}
                              onChange={handleInputChange}
                              checked={primaryDetails.is_interested === option}
                              className="form-radio"
                            />
                          </div>
                        </div>
                      ))}
                    </div>
                    {isError.is_interested && (
                      <div className="form-error">
                        Please select an option
                      </div>
                    )}
                  </Form.Group>

                  <div className="form-btn-row">
                    <AppButton
                      onClick={handleBack}
                      variant="back"
                      className="form-btn variant-secondary"
                    >
                      ← Back
                    </AppButton>
                    <AppButton
                      onClick={handleNext}
                      variant="next"
                      className="form-btn variant-primary"
                      disabled={!isFormValid()}
                    >
                      Next →
                    </AppButton>
                  </div>
                </Form>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default InterestedMayaSolution;
